export default "__VITE_ASSET__pSlI7bFm__"